//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useStore } from '../../../../store/store';
import { useNav } from 'src/onboarding/hooks/nav';

import styles from './style.module.scss';
import { t } from '@web-solutions/module-localization';
import { useUpsalePurchase } from 'core/upsale/hooks/use-upsale-purchase';
import Analytics from '@web-solutions/module-analytics';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import Button from 'src/onboarding/components/ui/button/Button';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import FailedPayment from '../failedPaymentPopup';
import SuccessPayment from '../successPaymentPopup';
import { ReactComponent as LoadingIcon } from '../../../../assets/images/loading-white.svg';
import upsaleBundle from '../../../../assets/images/upsale-nutrition-bundle.png';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import instance from 'src/onboarding/api/interceptor';
import { Title } from 'src/onboarding/components/typography/Title/Title';

const UpsaleNutritionBundle = () => {
  const { onNext } = useNav();
  const email = useStore((state) => state.email);

  const { upsaleNutritionBundle } = useRemoteConfig();

  const [successPayment, setSuccessPayment] = useState(false);
  const [showCheck, setShowCheck] = useState(false);

  const [failedPayment, setFailedPayment] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const { handleUpsalePurchase, renderPaymentProcessor } = useUpsalePurchase();

  const sendNutritionBundleRequest = async () => {
    try {
      const payload = {
        email,
        bundle: 'Bundle',
        template: 'nutrition-cooking-bundle-clean',
        subject: 'Cooking & Nutrition Bundle',
      };

      const response = await instance.post('/user/nutrition-cooking-bundle', payload);
      return response.data;
    } catch (error) {
      console.error('Error sending bundle request:', error);
    }
  };

  const handlePurchaseAndProceed = async (recurlyId) => {
    setLoading(true);

    try {
      const data = await handleUpsalePurchase({
        recurlyId,
        upsaleName: upsaleNutritionBundle.upsaleName,
        isNextStepBlocked: true,
      });

      if (!data) {
        setFailedPayment(true);
        return;
      }

      Analytics.trackEvent('step', 'completed', {
        upsaleID: 'upsale-nutrition-bundle',
        result: 'upsale-nutrition-bundle_payment',
      });

      gtag('event', 'conversion', {
        send_to: 'AW-17149973324/WBLJCNvSyP0aEMym3_E_',
        value: upsaleNutritionBundle.priceAmount,
        currency: 'USD',
        transaction_id: '',
      });

      await sendNutritionBundleRequest();

      setSuccessPayment(true);
      setFailedPayment(false);
    } catch (error) {
      console.error('Purchase error:', error);
      setFailedPayment(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (successPayment) {
      document.body.style.overflow = 'hidden';

      const showCheckTimer = setTimeout(() => setShowCheck(true), 500);
      const nextTimer = setTimeout(() => onNext(), 1500);

      return () => {
        clearTimeout(showCheckTimer);
        clearTimeout(nextTimer);
        document.body.style.overflow = '';
      };
    } else if (failedPayment) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [successPayment, failedPayment]);

  useEffect(() => {
    if (failedPayment) {
      const timer = setTimeout(() => setLoading(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [failedPayment]);

  return (
    <>
      <main className={styles.main}>
        <div className={styles.header}>
          <h2 className={styles.headerTitle}>{t('onboarding.upsaleNutritionBundle.title')}</h2>
          <Caption size='l' style={{ color: '#3F3F3F' }}>
            {t('onboarding.upsaleNutritionBundle.subTitle')}
          </Caption>
          <img src={upsaleBundle} className={styles.headerImg} alt='plans' />
        </div>

        <div className={styles.content}>
          {renderPaymentProcessor({
            activeProduct: upsaleNutritionBundle.product,
            oneTimeRecurlyId: upsaleNutritionBundle.recurlyId,
          })}

          <div className={styles.usersContainer}>
            <Text size='l' semibold className={styles.users}>
              {t('onboarding.upsaleNutritionBundle.users')}
            </Text>
            <Text size='m' medium style={{ color: '#8A8A8A' }}>
              {t('onboarding.upsaleNutritionBundle.description')}
            </Text>
          </div>

          <div className={styles.youGetContainer}>
            <Title tag='h4'>{t('onboarding.upsaleNutritionBundle.youGet.title')}</Title>
            <div className={styles.youGetOptions}>
              <Text size='m' medium className={styles.youGetOption}>
                {t('onboarding.upsaleNutritionBundle.youGet.recipes')}
              </Text>
              <Text size='m' medium className={styles.youGetOption}>
                {t('onboarding.upsaleNutritionBundle.youGet.insights')}
              </Text>
              {!upsaleNutritionBundle.movePriceToBottom && (
                <Text size='m' medium className={styles.youGetOption}>
                  {t('onboarding.upsaleNutritionBundle.youGet.access')}
                </Text>
              )}
              <Text size='m' medium className={styles.youGetOption}>
                {t('onboarding.upsaleNutritionBundle.youGet.strategies')}
              </Text>
            </div>
          </div>
        </div>
        {successPayment && (
          <SuccessPayment onClose={() => setSuccessPayment(false)} showCheck={showCheck} />
        )}

        {failedPayment && (
          <FailedPayment
            onClose={() => setFailedPayment(false)}
            onRetry={() => handlePurchaseAndProceed(upsaleNutritionBundle.recurlyId)}
            loading={loading}
          />
        )}
      </main>
      <footer className={styles.footer}>
        <Button
          disabled={loading}
          title={loading ? <LoadingIcon /> : t('onboarding.upsaleNutritionBundle.getBundle')}
          onClick={() => handlePurchaseAndProceed(upsaleNutritionBundle.recurlyId)}
        />
      </footer>
      <div
        className={styles.skip}
        style={upsaleNutritionBundle.movePriceToBottom ? { bottom: '-90px' } : { bottom: '-60px' }}
      >
        {upsaleNutritionBundle.movePriceToBottom && (
          <Caption size='m' style={{ color: '#B9B9B9' }}>
            {t('onboarding.upsaleNutritionBundle.youGet.access')}
          </Caption>
        )}
        <Button
          type='secondary'
          title={t('onboarding.upsaleNutritionBundle.skip')}
          onClick={() => {
            onNext();
          }}
        />
      </div>
    </>
  );
};

export default UpsaleNutritionBundle;
